import * as apis from 'common-mediax/src/apis'
// import moment from 'moment'
import { doEncrypt, doDecryptStr, generatePubAndPriKey } from 'common-mediax/src/common/sm2.js'
import { Message } from 'element-ui'

const SERVER_PUB_KEY_SM2 = '04195D1F93F950DDCC8C8384DD47DEBBD19B2897753686DE6B2EC87B583578325DF9191865258EB22A08AEFE4AA5E0EAD59D0EFB0187B0649EEF9008222BD3DA22'
const APP_KEY = 'mediax-dev-app'
const APP_SECRET = '367bde41-4eae-4c59-b151-47fc1ce83153'

import EventBus from 'common-mediax/src/common/EventBus';
import { EventBusDataKey } from 'common-mediax/src/common/GlobalEvent';
import { baseMods } from 'common-mediax/src/store/modules/MediaBatman/menu.js'
export default {
  namespaced: true,
  state: {
    Ticket: '',
    Mods: [], // 菜单模块列表
  },
  mutations: {
    SET_TICKET(state, data) {
      state.Ticket = data
    },
    // 菜单设置模块列表
    SET_MODS(state, data) {
      state.Mods = data
    },
  },
  actions: {
    FETCH_TOKEN ({state, commit, dispatch}, params) {
      return new Promise(async (resolve, reject) => {
        await generatePubAndPriKey();
        const APP_PUB_KEY = localStorage.getItem(EventBusDataKey.PUGC.APP_PUB_KEY) || ''
        const APP_PRI_KEY = localStorage.getItem(EventBusDataKey.PUGC.APP_PRI_KEY) || ''
        // 前端对参数加密
        const type = doEncrypt('app', SERVER_PUB_KEY_SM2) // token类型必须为app，必填
        const key = doEncrypt(APP_KEY, SERVER_PUB_KEY_SM2)// appKey，必填
        const secret = doEncrypt(APP_SECRET, SERVER_PUB_KEY_SM2) // appSecret，必填
        const publicKey = doEncrypt(APP_PUB_KEY, SERVER_PUB_KEY_SM2) // app运行时生成的公钥，必填

        let config = {
          params: {
            type,
            key,
            secret,
            publicKey,
            ...params
          }
        }
        setTimeout(async () => {
          const res = await apis.MediacloudReporter.getSecurityToken(config)
          if (Object.prototype.toString.call(res.data.data) === '[object Object]') {
            if (res.data.data.token = 'notoken') {
             window.sessionStorage.setItem(EventBusDataKey.PUGC.TOKEN_DATA, JSON.stringify({
                token: res.data.data.type,
                type: 'app',
                deltime: res.data.data.deltime,
                timeout: res.data.data.timeout,
              }))
              // window.sessionStorage.setItem('TOKEN_DATA', JSON.stringify({
              //   token: res.data.data.type,
              //   type: 'app',
              //   deltime: res.data.data.deltime,
              //   timeout: res.data.data.timeout,
              // }))
            }
          } else {
            // 需要解密
            // 前端解密，得到json字符串
            const pubData = doDecryptStr(res.data.data, APP_PRI_KEY)
            // 解密后缓存token相关数据,
            // window.sessionStorage.setItem('TOKEN_DATA', pubData)
           window.sessionStorage.setItem(EventBusDataKey.PUGC.TOKEN_DATA, pubData)
          }
          resolve();
        })
      })
    },
    GET_TICKET ({state, commit}) {
      let Ticket = '';
      const tokenDataNew = window.sessionStorage.getItem(EventBusDataKey.PUGC.TOKEN_DATA) || "{}";
      // const tokenDataNew = window.sessionStorage.getItem("TOKEN_DATA") || "{}";
      const tokenDataJsonNew = JSON.parse(tokenDataNew);
      if (tokenDataJsonNew && tokenDataJsonNew.token) {
        // {"token":获取到的token,"secret":打包时的appSecret,"timestamp":当前时间} 加密成字符串，赋值给ticket
        const ticketJson = {
          token: tokenDataJsonNew.token,
          secret: APP_SECRET,
          timestamp: new Date().getTime()
        };
        Ticket = doEncrypt(ticketJson, SERVER_PUB_KEY_SM2)
      }
      commit('SET_TICKET', Ticket)
    },
    // 投稿平台刷新accessToken
    REFRESH_ACCESS_TOKEN ({state, commit, dispatch}, params) {
      return new Promise(async (resolve, reject) => {
        let loginInfo = localStorage.getItem('loginInfo')
        try {
          loginInfo = JSON.parse(loginInfo)
        } catch (err) {
          console.log(err)
        }
        if (loginInfo) {
          const params = {
            params: {
              refreshToken: loginInfo.refreshToken,
              imei: window.localStorage.getItem('batman_virtualDeviceId')
            },
            headers: {
              source: 'batman'
            }
          }
          const res = await apis.MediacloudReporter.postRefreshAccessToken(params);
          if (res.data.status == 0) {
            let d = res.data.data
            if (d.hasOwnProperty('success')) {
              if (!d.success) {
                Message.warning('登录失效，请重新登录')
                setTimeout(() => {
                  let siteId = localStorage.getItem('siteId')
                  location.href = `/login?siteId=${siteId}`
                }, 1000)
                return false
              }
            }
            loginInfo = {
              ...loginInfo,
              accessToken: d.accessToken,
              accessTokenTimeout:d.accessTokenTimeout,
              refreshToken:d.refreshToken,
              refreshTokenTimeout:d.refreshTokenTimeout,
              token: d.token,
              authToken: d.token
            }
            if (!d.token) {
              loginInfo['token'] = d.accessToken;
              loginInfo['authToken'] = d.accessToken;
            }
            localStorage.setItem('loginInfo', JSON.stringify(loginInfo))
            resolve()
          }
        }else {
          resolve()
        }
      })
    },
    /**
     * 获取投稿平台所有模块
     * @param {Object} permissions 模块权限
     * @param {Object} accountInfo 身份信息
     * @param {Object} mods 模块列表
     * @return {Object} identifyType 身份 expert:专家 correspondent:通讯员 we_media:自媒体
     */
    FETCH_MODS ({commit}, {permissions, accountInfo}) { 
      // 动态设置一级模块 disabled
      const mods = baseMods.map(mod => ({
        ...mod,
        disabled: !permissions?.[mod.identifyType], // 无权限则禁用
        accountInfo: accountInfo?.[mod.identifyType] ?? null
      }));
      commit('SET_MODS', mods)
    }
    // SET_LOGS ({state, commit, dispatch}, logs) {
    //   try {
    //     let authenticationInfo = window.localStorage.getItem('authenticationInfo') || '{}'
    //     if(authenticationInfo) {
    //       authenticationInfo = JSON.parse(authenticationInfo);
    //     }
    //     let loginInfo = window.localStorage.getItem('loginInfo') || '{}'
    //     if(loginInfo) {
    //       loginInfo = JSON.parse(loginInfo);
    //     }
    //     let options = {
    //       name: authenticationInfo.accountName || loginInfo.nickName || '',
    //       time: moment().format('YYYY-MM-DD HH:mm:ss'),
    //       ip: '',
    //       action: '',
    //       remarks: `${authenticationInfo.accountName || loginInfo.nickName || ''}（${authenticationInfo.userId || loginInfo.userid || ''}）`,
    //       type: '用户管理',
    //       ...logs,
    //     }
    //     console.log(options)
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }
  }
}
